(() => {
  const openers = new WeakMap();
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tus-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.tusOpen);
      if (dialog && !dialog.open) {
        openers.set(dialog, trigger);
        trigger.setAttribute('aria-expanded', 'true');
        dialog.showModal();
        document.documentElement.classList.add('tus-modal-open');
      }
    }
    const closer = event.target.closest('[data-tus-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.matches('.tus-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const link = event.target.closest('.tus-dialog a');
    if (link) link.closest('dialog').close();
  });
  document.addEventListener('close', (event) => {
    if (!event.target.matches('.tus-dialog')) return;
    const opener = openers.get(event.target);
    opener?.setAttribute('aria-expanded', 'false');
    if (!document.querySelector('.tus-dialog[open]')) document.documentElement.classList.remove('tus-modal-open');
    opener?.focus();
  }, true);
})();
